import { render, staticRenderFns } from "./FileBrowserBtn.vue?vue&type=template&id=6838e3ba"
import script from "./FileBrowserBtn.vue?vue&type=script&lang=ts"
export * from "./FileBrowserBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports